import { render, staticRenderFns } from "./signupMentor.vue?vue&type=template&id=061d6a00&scoped=true"
import script from "./signupMentor.vue?vue&type=script&lang=js"
export * from "./signupMentor.vue?vue&type=script&lang=js"
import style0 from "./signupMentor.vue?vue&type=style&index=0&id=061d6a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061d6a00",
  null
  
)

export default component.exports